import { render, staticRenderFns } from "./LiveAnswering.vue?vue&type=template&id=e72b6280"
import script from "./LiveAnswering.vue?vue&type=script&lang=js"
export * from "./LiveAnswering.vue?vue&type=script&lang=js"
import style0 from "./LiveAnswering.vue?vue&type=style&index=0&id=e72b6280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports